import { useLazyQuery } from "@apollo/client";
import { GET_PRESCRIPTIONS, GET_PRESCRIPTION_BY_ID, GET_MEDICINE_URL_BY_ID } from "./prescriptions.query";
import {
  IGetPrescriptionsResponse,
  IGetPrescriptionByIdResponse,
  IGetMedicineUrlResponse,
} from "./prescriptions.interface";
import { mapPrescriptionsResponse, mapPrescriptionDetailsResponse } from "./prescriptions.mapper";
import { useCallback } from "react";

export const usePrescriptions = () => {
  const [getOnlinePharmacyPrescriptions, { data, loading, error }] =
    useLazyQuery<IGetPrescriptionsResponse>(GET_PRESCRIPTIONS, {
      fetchPolicy: "network-only",
    });

  const executeGetPrescriptions = useCallback((petId?: string) => {
    getOnlinePharmacyPrescriptions({
      variables: { petId: petId === "all" ? undefined : petId },
    });
  }, [getOnlinePharmacyPrescriptions]);

  return {
    executeGetPrescriptions,
    data: mapPrescriptionsResponse(data),
    loading,
    error,
  };
};

export const usePrescriptionById = () => {
  const [getPrescriptionById, { data, loading, error }] =
    useLazyQuery<IGetPrescriptionByIdResponse>(GET_PRESCRIPTION_BY_ID);

  const executeGetPrescriptionById = useCallback(
    (id: string) => {
      getPrescriptionById({
        variables: { id },
        fetchPolicy: "network-only",
      });
    },
    [getPrescriptionById],
  );

  return {
    executeGetPrescriptionById,
    data: mapPrescriptionDetailsResponse(data),
    loading,
    error,
  };
};

export const useMedicineUrl = () => {
  const [getMedicineUrl, { data, loading, error }] = useLazyQuery<IGetMedicineUrlResponse>(GET_MEDICINE_URL_BY_ID);

  const executeGetMedicineUrl = useCallback(
    (itemId: string) => {
      getMedicineUrl({
        variables: { itemId },
        fetchPolicy: "network-only",
      });
    },
    [getMedicineUrl],
  );

  return {
    executeGetMedicineUrl,
    url: data?.getOnlinePharmacyItems?.url,
    loading,
    error,
  };
};
